//export class ProjectJobNumberListPageComponent extends ListPageComponent {
  //protected listPageComponentList: ProjectJobNumberList = new  ProjectJobNumberList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class ProjectJobNumberBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: ProjectJobNumberGeneratedForm}];
//};

//export class ProjectJobNumberListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: ProjectJobNumberListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/ProjectJobNumberDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class ProjectJobNumberEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/projectJobNumber/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class ProjectJobNumberFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public contractManagerId: IFieldOptions = { field: "contractManagerId" };
	public sysproJobNo: IFieldOptions = { field: "sysproJobNo" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public siteId: IFieldOptions = { field: "siteId" };
	public custPrefix: IFieldOptions = { field: "custPrefix" };
	public custName: IFieldOptions = { field: "custName" };
	public branch: IFieldOptions = { field: "branch" };
	public sisproTimestamp: IFieldOptions = { field: "sisproTimestamp" };
	public sisproTimestampExt: IFieldOptions = { field: "sisproTimestampExt" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.contractManagerId);
		this.push(this.sysproJobNo);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.siteId);
		this.push(this.custPrefix);
		this.push(this.custName);
		this.push(this.branch);
		this.push(this.sisproTimestamp);
		this.push(this.sisproTimestampExt);
	}
}

export class ProjectJobNumberForm implements IFormOptions {
	protected projectJobNumberFormName: string = "projectJobNumberForm";
	protected projectJobNumberFormModel: models.ProjectJobNumberDTO = new models.ProjectJobNumberDTO();
	protected projectJobNumberFormEndPoints: ProjectJobNumberEndPoints = new ProjectJobNumberEndPoints();
	protected projectJobNumberFormFields: ProjectJobNumberFormFields = new ProjectJobNumberFormFields();
	public get name(): string { return this.projectJobNumberFormName };
	public get model(): models.ProjectJobNumberDTO { return this.projectJobNumberFormModel };
	public get endPoints(): IEntityEndPoints { return this.projectJobNumberFormEndPoints };
       public set endPoints(projectJobNumberEndPoints: IEntityEndPoints) {
		this.projectJobNumberFormEndPoints = projectJobNumberEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): ProjectJobNumberFormFields { return this.projectJobNumberFormFields };
}

export class ProjectJobNumberListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public contractManagerId: IColumnOptions = { field: "contractManagerId" };
	public sysproJobNo: IColumnOptions = { field: "sysproJobNo" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public siteId: IColumnOptions = { field: "siteId" };
	public custPrefix: IColumnOptions = { field: "custPrefix" };
	public custName: IColumnOptions = { field: "custName" };
	public branch: IColumnOptions = { field: "branch" };
	public sisproTimestamp: IColumnOptions = { field: "sisproTimestamp" };
	public sisproTimestampExt: IColumnOptions = { field: "sisproTimestampExt" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.contractManagerId);
		this.push(this.sysproJobNo);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.siteId);
		this.push(this.custPrefix);
		this.push(this.custName);
		this.push(this.branch);
		this.push(this.sisproTimestamp);
		this.push(this.sisproTimestampExt);
	}
}

export class ProjectJobNumberList implements IGridOptions {
	protected projectJobNumberListName: string = "projectJobNumberList";
	protected projectJobNumberListModel: models.ProjectJobNumberDTO = new models.ProjectJobNumberDTO();
	protected projectJobNumberListEndPoints: ProjectJobNumberEndPoints = new ProjectJobNumberEndPoints();
	protected projectJobNumberListColumns: ProjectJobNumberListColumns = new ProjectJobNumberListColumns();
	public projectJobNumberForm: ProjectJobNumberForm = new ProjectJobNumberForm();
	public get name(): string { return this.projectJobNumberListName };
	public get model(): models.ProjectJobNumberDTO { return this.projectJobNumberListModel };
	public get endPoints(): IEntityEndPoints { return this.projectJobNumberListEndPoints };
	public set endPoints(projectJobNumberEndPoints: IEntityEndPoints) {
		this.projectJobNumberListEndPoints = projectJobNumberEndPoints;
		this.projectJobNumberForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): ProjectJobNumberListColumns { return this.projectJobNumberListColumns };
}

export class ProjectJobNumberEntity implements IEntityOptions {
	protected projectJobNumberEntityName: string = "projectJobNumberEntity";
	protected projectJobNumberEntityModel: models.ProjectJobNumberDTO = new models.ProjectJobNumberDTO();
	protected projectJobNumberEntityEndPoints: ProjectJobNumberEndPoints = new ProjectJobNumberEndPoints();
	protected projectJobNumberEntityList: ProjectJobNumberList = new ProjectJobNumberList();
	public get name(): string { return this.projectJobNumberEntityName };
	public get model(): models.ProjectJobNumberDTO { return this.projectJobNumberEntityModel };
	public get endPoints(): IEntityEndPoints { return this.projectJobNumberEntityEndPoints };
	public set endPoints(projectJobNumberEndPoints: IEntityEndPoints) {
		this.projectJobNumberEntityEndPoints = projectJobNumberEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): ProjectJobNumberList { return this.projectJobNumberEntityList };
	public get form(): ProjectJobNumberForm { return this.grid.projectJobNumberForm };
	constructor(name?: string) {
		if (name) this.projectJobNumberEntityName = name;
		this.endPoints = this.projectJobNumberEntityEndPoints;
	}
};
//export class ProjectJobNumberGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: ProjectJobNumberForm = new ProjectJobNumberForm();
//};

